/* eslint-disable @typescript-eslint/default-param-last */
import { IInterviewersAction } from '../../types/Interviews/interviewers.types';
import { GET_ALL_INTERVIEWERS_SUCCESS } from '../../constants/ActionTypes';
import initialState from '../../store/initialState';

const interviewersReducer = (
  state = initialState.interviewers,
  action: IInterviewersAction
) => {
  switch (action.type) {
    case GET_ALL_INTERVIEWERS_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default interviewersReducer;
